import { jsx as l } from "react/jsx-runtime";
import { EditableComponent as T } from "@adobe/aem-react-editable-components";
import { AuthoringUtils as v } from "@adobe/aem-spa-page-model-manager";
import f, { useRef as $, useContext as D, useState as W, useEffect as P, useMemo as d } from "react";
import { u as j } from "./PageContext-57b2437f.js";
import { g as h, h as z } from "./component-a7888ba1.js";
import { m as L } from "./EditableComponentUtils-0b5699b7.js";
import "html-react-parser";
import "sanitize-html";
import { useIsMounted as _ } from "@ucl/react-library/useIsMounted";
import { C as k } from "./ComponentContext-3bb2d205.js";
import { withErrorBoundary as B } from "./withErrorBoundary.js";
import { c as O } from "./index-0371017d.js";
import U, { css as G } from "styled-components";
function H(e) {
  const r = /* @__PURE__ */ f.forwardRef((t, a) => {
    const o = _(), u = $(), i = D(k), [m, c] = W(() => t.id && (i == null ? void 0 : i.get(t.id, t).props.value) || t);
    return P(() => c(t), [
      t
    ]), P(() => {
      if (!(!o() || !t.id))
        return u.current = i == null ? void 0 : i.get(t.id).props.subscribe((s) => {
          z(m, s) && c({
            ...m,
            ...s
          });
        }), () => {
          var s;
          return (s = u.current) == null ? void 0 : s.unsubscribe();
        };
    }, [
      m,
      i,
      t.id,
      o
    ]), m.hidden ? null : /* @__PURE__ */ l(e, {
      ref: a,
      ...m
    });
  });
  return r.displayName = `withComponentManager(${h(e)})`, r;
}
function I(e, r) {
  const t = /* @__PURE__ */ f.forwardRef((a, o) => e.isEmpty({
    ...a,
    ...a.directProps
  }) ? null : /* @__PURE__ */ l(r, {
    ref: o,
    ...a
  }));
  return t.displayName = `withEmpty(${h(r)})`, t;
}
function J(e) {
  const r = /* @__PURE__ */ f.forwardRef(({ updateProps: t, ...a }, o) => {
    const u = $(t);
    P(() => {
      u.current = t;
    }, [
      t
    ]);
    const i = d(() => {
      var c;
      const m = {
        ...a,
        ...a.analyticsData,
        ...a.directProps
      };
      return {
        ...m,
        ...(c = u.current) == null ? void 0 : c.call(u, m)
      };
    }, [
      a
    ]);
    return /* @__PURE__ */ l(e, {
      ref: o,
      ...i
    });
  });
  return r.displayName = `withFlattenProps(${h(e)})`, r;
}
const K = /* @__PURE__ */ U.div.withConfig({
  displayName: "withSpacer__Spacer",
  componentId: "sc-db144db7-0"
})([
  "&.Spacer{",
  "}"
], ({ theme: { components: { spacer: e } } }) => /* @__PURE__ */ G(e.AemSpacer));
function Q(e, r) {
  const t = /* @__PURE__ */ f.forwardRef((a, o) => r.disableResizable || a.disableResizable ? /* @__PURE__ */ l(e, {
    ref: o,
    ...a,
    forwardedAs: a.as
  }) : /* @__PURE__ */ l(K, {
    ref: o,
    ...a,
    as: e,
    forwardedAs: a.as,
    className: O([
      "Spacer",
      a.className
    ])
  }));
  return t.displayName = `withSpacer(${h(e)})`, t;
}
function me(e, r) {
  const t = I(e, r), a = H(t), o = Q(a, e), u = J(o), i = /* @__PURE__ */ f.forwardRef(({ parentCqItems: c, parentCqPath: s, updateProps: S, ...n }, R) => {
    const { pagePath: E } = j(), g = v.isInEditor(), [M, y] = d(() => (s == null ? void 0 : s.split("/jcr:content/")) || [
      E
    ], [
      s,
      E
    ]), x = d(() => {
      var N;
      if (y)
        return n.name ? `${y}/${n.name}` : y;
      const b = (N = e.resourceType) == null ? void 0 : N.split("/").pop();
      return n.name ? `root/responsivegrid/${b}_${n.name}` : `root/responsivegrid/${b}`;
    }, [
      n.name,
      y
    ]), w = d(() => L(n.model || (c == null ? void 0 : c[n.name || ""])), [
      c,
      n.model,
      n.name
    ]), A = d(() => n.name ? `${e.emptyLabel} - ${n.name}` : e.emptyLabel, [
      n.name
    ]), F = {
      ...e,
      isEmpty: (b) => e.isEmpty({
        ...b,
        ...n
      }),
      emptyLabel: A
    };
    return !g && w && !Object.keys(w).length ? null : /* @__PURE__ */ l(T, {
      ...n,
      config: F,
      removeDefaultStyles: !0,
      model: w,
      pagePath: n.pagePath ?? M,
      itemPath: n.itemPath ?? x,
      cqPath: g || !n.model ? n.cqPath : "",
      children: /* @__PURE__ */ l(u, {
        ref: R,
        ...n,
        directProps: n,
        updateProps: S,
        dataTestId: n.name
      })
    });
  });
  i.displayName = `Editable${h(r)}`;
  const m = B(i);
  return m.resourceType = e.resourceType, m;
}
export {
  H as a,
  me as b,
  I as w
};
